import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Servicio } from '../models/servicio';
import { DataComboServicio } from '../models/combo';

@Injectable({
  providedIn: 'root'
})

export class ServicioService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.url + 'servicio/';
  }

  getServiciosByBaseServicioId(id: number): Observable<Servicio[]> {
    let urlcom = this.url + id + '/tiendas';
    return this.http.get<Servicio[]>(urlcom);
  }

  getById(id: number): Observable<Servicio> {
    let urlcom = this.url + id;
      return this.http.get<Servicio>(urlcom);
  }

  update(id: number, data: Servicio): Observable<Servicio> {
    let urlcom = this.url + id;
    return this.http.put<Servicio>(urlcom, data);
  }

  updateServicios(data: Array<Servicio>): Observable<Array<Servicio>> {
    return this.http.put<Array<Servicio>>(this.url, data);
  }

  save(data: Servicio): Observable<Servicio> {
    let urlcom = this.url + "register/";
    return this.http.post<Servicio>(urlcom, data);
  }

  delete(id: number): Observable<any> {
    let urlcom = this.url + id;
    return this.http.delete(urlcom);
  }

  activate(id: number): Observable<any> {
    let urlcom = this.url + "activate/" + id;
    return this.http.put(urlcom, null);
  }

  getServiciosCombo(tiendaId: number): Observable<DataComboServicio[]> {
    let urlcom = this.url + "combo/" + tiendaId;
    return this.http.get<DataComboServicio[]>(urlcom);
  }

}
